module.exports = __webpack_public_path__ + "img/2_0.31854f7a.png";